import store from '../../store'
import { MZCAPI } from '../../helpers/http-mzcapi'
import configMixin from '../../mixins/configMixin'
let appConfigs = require(`../../assets/client/${process.env.CLIENTID}/site_config.json`)

export default {
  mixins: [configMixin],
  getFromConsumerStoreProfile (parameters, coordinates, token, radius = 'from-profile') {
    console.log('getFromConsumerStoreProfile')
    console.log('coordinates', coordinates)
    if (coordinates && !isNaN(coordinates.latitude) && !isNaN(coordinates.longitude)) {
      console.log('Inside coordinates')
      let apiEndpoint = `/consumer/stores/${coordinates.latitude}/${coordinates.longitude}/${radius}`

      return MZCAPI.get(apiEndpoint, {
        headers: {
          Authorization: token,
          MZScope: 'with-children',
          'x-mzaccount': store.getters.appConfig.api_account
        },
        params: parameters
      })
    } else {
      let defaultCoords = appConfigs.defaultCoords
      let apiEndpoint = `/consumer/stores/${defaultCoords.latitude}/${defaultCoords.longitude}/${radius}`

      return MZCAPI.get(apiEndpoint, {
        headers: {
          Authorization: token,
          MZScope: 'with-children',
          'x-mzaccount': store.getters.appConfig.api_account
        },
        params: parameters
      })
    }
  },
  getFromConsumerGuestStore (parameters, coordinates, token, radius = 1000000000000) {
    console.log('getFromConsumerGuestStore')
    console.log('coordinates', coordinates)
    let apiEndpoint = `/consumer/public/stores/${coordinates.latitude}/${coordinates.longitude}/${radius}`

    return MZCAPI.get(apiEndpoint, {
      headers: {},
      params: parameters
    })
  },
  getFromConsumerCoupons (parameters, token) {
    let apiEndpoint = `/consumer/coupons`

    return MZCAPI.get(apiEndpoint, {
      headers: {
        Authorization: token,
        MZScope: 'with-children',
        'x-mzaccount': store.getters.appConfig.api_account
      },
      params: parameters
    })
  },
  getApplicationMeta () {
    let apiEndpoint = `/apps/${process.env.APPID}/meta`
    return MZCAPI.get(apiEndpoint)
  },
  logInActivityLog (token, type, id, logName, description, properties, store) {
    let apiEndpoint = `/consumer/log/${type}/${id}`
    let payload = {
      'log_name': logName,
      'description': description,
      'properties': properties,
      'store': store
    }
    return MZCAPI.post(apiEndpoint, payload, {
      headers: {
        Authorization: token
      }
    })
  },
  getShortUrl (token, name, url, type, scope, scopeId) {
    let apiEndpoint = `consumer/shorturl`
    let payload = {
      'name': name,
      'url': url,
      'usage_type': type,
      'scope': scope,
      'scope_id': scopeId
    }
    return MZCAPI.post(apiEndpoint, payload, {
      headers: {
        Authorization: token,
        MZScope: 'with-children'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/mzcapi/index.js